import { setCircleSwatchWidth } from './product-card-shape-swatches.js';
import { bindSwatchesClick, bindQuickAddSizeBtnClick, bindQuickAddMobileClick } from './quick-purchase.js';

const interval = setInterval(() => {
    if (document.querySelector('.recently-viewed__container .product-card')) {
      clearInterval(interval);
      console.log('Recently viewed loaded!');
      // 你可以在这里执行后续逻辑
      setCircleSwatchWidth(".recently-viewed__container");
      bindSwatchesClick(".recently-viewed__container");
      bindQuickAddSizeBtnClick(".recently-viewed__container");
      bindQuickAddMobileClick(".recently-viewed__container");
    }
}, 100);